/**
 * Proyecto: MOGOTAX-SERVER
 * Autor: Megatrack GPS SAS
 * Fecha de creación: 11 de noviembre 2024
 * Licencia: Propiedad Privada
 *
 * Este código es propiedad exclusiva de Megatrack GPS SAS & Mogotax SAS y no puede ser distribuido, copiado, modificado, publicado, sublicenciado ni comercializado sin el consentimiento expreso y por escrito de ambas empresa.
 *
 * Copyright (c) 2025 Megatrack GPS SAS. Todos los derechos reservados.
 */
import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import { useUser } from "./UserContext";

const ProtectedRoute = ({ children }) => {
  const { user } = useUser();

  if (!user) {
    const savedUser = localStorage.getItem("user");
    if (savedUser) {
      // Verificar si el usuario guardado requiere cambio de contraseña
      try {
        const parsedUser = JSON.parse(savedUser);
        if (parsedUser.requiere_cambio_password) {
          return <Navigate to="/change-password?mandatory=true" />;
        }
      } catch (e) {
        // Si hay error al parsear, continuar normal
      }
      return children;
    }
    return <Navigate to="/login" />;
  }

  // Verificar si el usuario requiere cambio de contraseña
  if (user.requiere_cambio_password) {
    return <Navigate to="/change-password?mandatory=true" />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ProtectedRoute;
